import { DatePicker } from '@mui/x-date-pickers-pro';
import React from 'react';

import {
  getDefaultDatePickerMaxDate,
  getDefaultDatePickerMinDate,
} from './FormDatePicker.constants';

const FormComponent: React.FC<{
  disabled?: boolean;
  error?: any;
  helperText?: string;
  label?: string;
  name: string;
  minDate?: Date;
  maxDate?: Date;
  onBlur?: any;
  onChange?: any;
  other?: object;
  placeholder: string;
  readonly?: boolean;
  required?: boolean;
  size?: 'small' | 'medium';
  slotProps?: any;
  value?: any;
}> = (props) => {
  const {
    disabled = false,
    error,
    helperText = '',
    label,
    name,
    minDate,
    maxDate,
    onBlur,
    onChange,
    other = {},
    placeholder,
    readonly = false,
    required = false,
    size = 'small',
    slotProps = {},
    value,
  } = props;

  const textFieldSlotProps = {
    fullWidth: true,
    error,
    size,
    name,
    onBlur: (event: React.FocusEvent<HTMLInputElement>) => {
      slotProps.textField?.onBlur?.(event);
      onBlur?.(event);
    },
    placeholder,
    helperText,
    ...slotProps.textField,
    slotProps: {
      ...slotProps.textField?.slotProps,
      htmlInput: {
        'data-testid': name,
        ...slotProps.textField?.slotProps?.htmlInput,
      },
    },
  };

  return (
    <DatePicker
      value={value}
      disabled={disabled}
      onChange={onChange}
      onAccept={() => onBlur?.()}
      onClose={() => onBlur?.()}
      label={`${label}${required ? '*' : ''}`}
      readOnly={readonly}
      minDate={minDate ?? getDefaultDatePickerMinDate()}
      maxDate={maxDate ?? getDefaultDatePickerMaxDate()}
      slotProps={{
        ...slotProps,
        textField: textFieldSlotProps,
      }}
      {...other}
    />
  );
};

export default FormComponent;
